import React, { useEffect, useRef, useState } from "react";
import {
    Anchor,
    Box,
    Center,
    createStyles,
    Group,
    Loader,
    Text,

} from "@mantine/core";
import {useMedplum } from "@medplum/react";

import { IconWorld } from "@tabler/icons-react";
import ChatUI from "./ChatNew";
import { PatientDetails } from "./Card";
import { IconMail } from "@tabler/icons-react";
import { useParams } from "react-router-dom";

import { getPatientName } from "../Eligibility/EligibiltyService";
import BorderFrame from "../Embed/Border";
import { startEducationChat } from "./educationService";

interface Details {
    form?: boolean;
    type?: 'chat' | 'qnr';
}

export const EmbedAIChat: React.FC<Details> = ({ form, type = 'chat' }) => {
    const useStyles = createStyles(() => ({
        mainBox: { width: "30%" },
        box1: { display: "flex", flexDirection: "column", gap: "16px", },
        box2: {
            gap: "8px",
            display: "flex",
            flexDirection: "column",
        },
        box3: {
            display: "flex",
            flexDirection: "column",
            border: "1px solid #EDEDED",
            borderRadius: "6px",
            gap: "12px",
            padding: "12px",
            overflowY: "auto",
            maxHeight: form ? "42vh" : "42vh",
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": {
                width: "1px",
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
            },
            "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
            },
        },
        box4: {
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            justifyContent: "flex-end",
        },
        box5: { display: "flex", flexDirection: "row", gap: "8px" },
        text: { fontWeight: 600, fontSize: "14px", lineHeight: "21px" },
        boxSelect: {
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            width: "100%",

        },
        boxSelect1: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            gap: "6px",
        },
        card: {
            padding: "10px",
            borderRadius: "8px",
            backgroundColor: "transparent",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
        },
        dragIcon: {
            marginRight: "10px",
            color: "#757575",
            cursor: "grab",
            minWidth: "fit-content",
            alignItems: "center",
        },
        checkbox: {
            marginRight: "10px",
        },
        checkText: {
            flexGrow: 1,
        },

        firstBox: {
            borderRadius: "8px",
            // marginLeft: "20px",
            // marginRight: "20px",
            // height: "100%",
            // paddingLeft: "2px",
            // paddingRight: "2px",
        },
        questionText: {
            fontWeight: 500,
            fontSize: "12px",
            // lineHeight: "2px",
        },
        boxQuestion: {
            border: "1px solid #EDEDED",
            width: "100%",
            padding: "16px",
            borderRadius: "10px",
            gap: "8px",
            display: "flex",
            flexDirection: "column",
        },
        callBox: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "55vh",
            gap: "10px",
            borderRadius: "8px",
            border: "1px solid #EDEDED ",
        },
        callText: {
            fontWeight: 500,
            fontSize: "14px",
            // lineHeight: "24px",
            color: "#242424",
        },
    }));
  

    const { classes } = useStyles();
    const medplum = useMedplum();
    const { code } = useParams();
    const patId = 'b2abee56-45dd-4df9-8b1a-d6a30fcab236';
    const [patient, setPatient] = useState<any>();
    const [showBorder, setShowBorder] = useState<boolean>(true);
    const [questionsText, setQuestionsText] = useState<any>([]);
    const [login, setLogin] = useState<boolean>(false);
    const [isCallLoading, setIsCallLoading] = useState<boolean>(false);
    const [qnrResId, setQnrResId] = useState<string>('');


    useEffect(() => {
        loginWithIdandSecret();
        if (login === true) {
            fetchData();
        }
    }, [login]);


 

    const loginWithIdandSecret = async () => {
        try {
            const decodedQuery = decodeURIComponent(code as string);

            const decodeQueryStringWithData = atob(decodedQuery);

            const queryParamss = decodeQueryStringWithData.split(",");
            const id = queryParamss[0];
            const secret = queryParamss[1];

            const login = await medplum.startClientLogin(id, secret);
            if (login) {
                setLogin(true);
                return true;
            }
        } catch (error) {
            console.error(error);
        }
    };
    const fetchData = async () => {

        try {
            // Get the patient data
            const patientData = await medplum.readResource('Patient', patId);
            setPatient(patientData);

            //StartChat 
            const chatRes = await startEducationChat(medplum, patId);
            setQnrResId(chatRes.qnrRes.id);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <BorderFrame showBorder={showBorder} >
            <Box 
                className={classes.firstBox}
                sx={{ height: showBorder ? "100vh" : "100%", }}
            >
                <Box
                    sx={{
                        display: "flex",
                        margin: "20px",
                        flexDirection: "column",
                        justifyContent: showBorder ? "space-between" : "",
                        gap: "10px",
                        height: "100%",
                        backgroundColor: "#F8F8F8",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "20px",
                            backgroundColor: "#F8F8F8",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px",
                                width: "100%",
                                // padding: "2px",
                            }}
                        >
                            <Box pt={0} sx={{ backgroundColor: "white" }}>
                                <PatientDetails
                                    name={getPatientName(patient?.name)}
                                    dob={patient?.birthDate ?? "--"}
                                    mobile={patient?.telecom?.[0]?.value}
                                    address={"--"}
                                    email={patient?.email ?? "--"}
                                    gender={patient?.gender ?? "--"}
                                    moreDetails={true}
                                    city={patient?.address?.[0]?.city}
                                    country={patient?.address?.[0]?.country}
                                    age={
                                        patient?.birthDate
                                            ? new Date().getFullYear() -
                                            new Date(patient.birthDate).getFullYear() -
                                            (new Date().setFullYear(0) <
                                                new Date(patient.birthDate).setFullYear(0)
                                                ? 1
                                                : 0)
                                            : "--"
                                    }
                                />
                            </Box>
                            <Box sx={{ display: "flex", height: "100%" }}>
                                <Box mih={"100%"} w={"100%"}>
                                    <Box p={"8px"} sx={{ backgroundColor: "white" }}>
                                        {isCallLoading && <Center display={'flex'} pos={"relative"} top={'30ch'}><Loader /></Center>}
                                        <ChatUI
                                            patientName={getPatientName(patient?.name)}
                                            dob={patient?.birthDate ?? "--"}
                                            mobile={patient?.telecom?.[0]?.value}
                                            patientId={patId}
                                            qtrResponseIdForChat={qnrResId}
                                            chatContext="medical-assistant"
                                            launchType={"education"}
                                            embed={true}
                                        />
                                    </Box>

                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* footer part */}
                    <Box
                        style={{
                            padding: "1rem 0",
                            borderTop: "1px solid #eaeaea",
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            justifyContent: "space-evenly",
                            backgroundColor: "rgb(243 250 255)",
                        }}
                    >
                        <Group spacing="xs">
                            <IconMail color="#228be6" size={20} />
                            <Text size="sm" color="blue">
                                <Anchor
                                    href="mailto:healthconnect@mindbowser.com"
                                    target="_blank"
                                >
                                    healthconnect@mindbowser.com
                                </Anchor>
                            </Text>
                        </Group>

                        <Group spacing="xs">
                            <IconWorld color="#228be6" size={20} />
                            <Text
                                sx={{
                                    cursor: "pointer",
                                    textDecoration: "none", // No underline by default
                                    "&:hover": {
                                        textDecoration: "underline", // Underline on hover
                                    },
                                }}
                                size="sm"
                                color="blue"
                                onClick={() =>
                                    window.open("https://healthconnect.mindbowser.com/")
                                }
                            >
                                healthconnect.mindbowser.com
                            </Text>
                        </Group>

                        <Text size="sm" color="blue">
                            © 2024 Mindbowser Inc. All rights reserved.
                        </Text>
                    </Box>
                </Box>
            </Box>
        </BorderFrame>
    );
};
